<template>
    <DashboardSectionCard
        :title="t('vue.dashboard_overview_attention_title')"
        :subtitle="t('vue.dashboard_overview_attention_subtitle')"
    >
        <p
            v-if="items.length === 0"
            class="rounded-md border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600"
        >
            {{ t("vue.dashboard_overview_attention_empty") }}
        </p>

        <div v-else class="grid gap-3">
            <div
                v-for="item in items"
                :key="item.code"
                class="flex items-start gap-3 rounded-md border border-gray-200 bg-white p-4"
            >
                <span
                    class="mt-2 h-2 w-2 shrink-0 rounded-full"
                    :class="severityDotClass(item.severity)"
                />
                <div class="min-w-0 flex-1">
                    <p class="font-medium text-gray-900">
                        {{ resolveTitle(item) }}
                    </p>
                    <p class="mt-1 text-sm text-gray-600">
                        {{
                            t(
                                `vue.dashboard_overview_attention_${item.code}_desc`,
                            )
                        }}
                    </p>
                </div>
                <Link
                    :href="route(item.routeName)"
                    class="shrink-0 text-[13px] font-medium leading-[18px] text-[#088BEA] hover:underline"
                >
                    {{ t(`vue.dashboard_overview_attention_${item.code}_cta`) }}
                </Link>
            </div>
        </div>
    </DashboardSectionCard>
</template>

<script lang="ts" setup>
import { Link } from "@inertiajs/vue3";
import route from "ziggy-js";
import { useTranslations } from "@/composables/useTranslations";
import DashboardSectionCard from "./DashboardSectionCard.vue";
import type {
    AttentionSeverity,
    IAttentionItem,
} from "@/types/Dashboard/IDashboardOverview";

defineProps<{
    items: IAttentionItem[];
}>();

const { t } = useTranslations();

const resolveTitle = (item: IAttentionItem): string => {
    const suffix = item.count === 1 ? "one" : "other";

    return t(`vue.dashboard_overview_attention_${item.code}_title_${suffix}`, {
        count: item.count,
    });
};

const severityDotClass = (severity: AttentionSeverity): string => {
    switch (severity) {
        case "critical":
            return "bg-red-500";
        case "warning":
            return "bg-orange-500";
        default:
            return "bg-gray-400";
    }
};
</script>
